import {
    Button as MaterialButton,
    CircularProgress as MaterialCircularProgress,
    Link,
} from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

import { themeColors } from '../../../utils/theme';

const Button = (props) => {
    const {
        type,
        children,
        startIcon,
        setTextDecoration,
        isLoading,
        disabled,
        linkColor,
        ...rest
    } = props;

    if (type === 'secondary') {
        return (
            <MaterialButton
                {...rest}
                variant="outlined"
                color={isLoading ? themeColors.loadingSecondaryButton : 'default'}
                startIcon={startIcon && startIcon}
                disabled={isLoading || disabled}
                className='secondary-button'
            >
                {children}
                {isLoading && <CircularProgress />}
            </MaterialButton>
        );
    }

    if (type === 'link') {
        return (
            <LinkButton {...rest}>
                {children}
            </LinkButton>
        );
    }

    return (
        <MaterialButton
            {...rest}
            variant="contained"
            color={isLoading ? 'inherit' : 'default'}
            disabled={isLoading || disabled}
            startIcon={startIcon && startIcon}
            className={isLoading ? 'loading-button' : 'primary-button'}
        >
            {!isLoading && children}
            {isLoading && <CircularProgress size={25} />}
        </MaterialButton>
    );
};

Button.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    isLoading: PropTypes.bool,
    startIcon: PropTypes.node,
    options: PropTypes.array,
    badgeCount: PropTypes.number,
    color: PropTypes.string,
    setTextDecoration: PropTypes.bool,
    linkColor: PropTypes.string,
    disabled: PropTypes.bool,
};

export default Button;

const CircularProgress = styled(MaterialCircularProgress)({
    position: 'absolute',
    color: 'white',
});

const LinkButton = styled(Link)(({ $linkColor, $setTextDecoration, color }) => ({
    color: color ? color : 'var(--primary-color)',
    cursor: 'pointer',
    fontWeight: 'bold',
    textDecoration: $setTextDecoration ? 'underline' : 'none',
    ...(!!$linkColor && { color: $linkColor }),
}));
